import { LegalMentionsSettings } from '@features/invoicingSettings/types/legalSettings/legalMentionsSettings'

export const getLegalMentionsDefaultValues = (): LegalMentionsSettings => {
  return {
    custom: {
      earlyPaymentDiscount: null,
      latePaymentPenaltyRate: null,
      vatExemptionScheme: null,
    },
  }
}
